import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteIcon from '../../assets/icons/delete.svg';
import EditIcon from '../../assets/icons/green_edit.svg';
import ScreenLoader from '../../components/common/ScreenLoader';
import DeletePermissionsModal from '../../components/common/modals/delete';
import EditSubjectModal from '../../components/common/modals/subjects/edit_subject';
import { subjectsTableHeader } from '../../constants/appConstants';
import { setSubjects } from '../../redux/slice/appSlice';
import { AuthenticatedGETRequest } from '../../utils';

const Subjects = ({ createNotification }) => {
    const { subjects } = useSelector((state) => state.appReducer);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [editDetails, setEditDetails] = useState(null);

    useEffect(() => {
        setLoading(true);
        const fetchSubjects = async () => {
            try {
                const { data } = await AuthenticatedGETRequest('subjects');
                dispatch(setSubjects(data));
                setLoading(false);
            } catch (error) {
                createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
                setLoading(false);
            }
        };
        fetchSubjects();
        // eslint-disable-next-line
    }, [createNotification]);

    return loading ? (
        <ScreenLoader />
    ) : (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            <div className='flex justifyCenter alignCenter w-100'>
                <h2>
                    مضامین کی مجموعی تعداد :
                    <span
                        style={{
                            fontFamily: 'CircularStd',
                            fontSize: 26,
                            marginRight: 8,
                            color: '#2196f3',
                        }}
                    >
                        {subjects.length}
                    </span>
                </h2>
            </div>

            {subjects ? (
                <div className='flex column w-100'>
                    <div className='flex justifyStart alignCenter table_header'>
                        {subjectsTableHeader.map((header, index) => (
                            <h3
                                key={index + 1}
                                className='table_header_element'
                                style={{
                                    width:
                                        index === 0
                                            ? 120
                                            : index === 1
                                            ? 320
                                            : index === 2
                                            ? 180
                                            : index === 3
                                            ? 180
                                            : 180,
                                    textAlign: index === 0 || index === 1 ? 'right' : 'center',
                                }}
                            >
                                {header}
                            </h3>
                        ))}
                    </div>

                    <div className='flex column justifyStart alignCenter tabe_data_row'>
                        {subjects.length > 0 &&
                            subjects.map((subjectEntity, index) => (
                                <div
                                    className='flex justifyStart alignCenter table_row'
                                    key={index + 1}
                                >
                                    <h4 style={{ width: 120, textAlign: 'right' }}>{index + 1}</h4>
                                    <h3 style={{ width: 320, textAlign: 'right' }}>
                                        {subjectEntity.name}
                                    </h3>
                                    <div
                                        className='flex justifyCenter alignCenter'
                                        onClick={() => {
                                            setEditDetails({
                                                id: subjectEntity.id,
                                                name: subjectEntity.name,
                                            });
                                            setEditModal(true);
                                        }}
                                        style={{ width: 180 }}
                                    >
                                        <img
                                            src={EditIcon}
                                            alt='edit_icon'
                                            height={22}
                                            width={22}
                                        />
                                    </div>
                                    <div
                                        className='flex justifyCenter alignCenter'
                                        onClick={() => {
                                            setDeleteModal(true);
                                            setDeleteId(subjectEntity.id);
                                        }}
                                        style={{ width: 180 }}
                                    >
                                        <img
                                            src={DeleteIcon}
                                            alt='delete_icon'
                                            height={32}
                                            width={32}
                                        />
                                    </div>
                                </div>
                            ))}

                        {subjects.length === 0 && (
                            <div className='flex justifyCenter alignCenter table_row'>
                                <h3>{`ایدمین کی طرف سے کوئی مضامین کا کوئی ڈیٹا موصول نہیں ہوا۔`}</h3>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <ScreenLoader />
            )}

            <DeletePermissionsModal
                label='مضامین کا ریکارڈ حذف کریں'
                description='کیا آپ اس مضمون کے ریکارڈ کو مستقل طور پر حذف کرنے کا یقین رکھتے ہیں؟'
                btnText='حذف کریں'
                open={deleteModal}
                id={deleteId}
                screen='subjects'
                onClose={() => setDeleteModal(false)}
            />

            {editModal && editDetails && (
                <EditSubjectModal
                    data={editDetails}
                    open={editModal}
                    onClose={() => setEditModal(false)}
                    onError={(error) => createNotification('error-toast', error)}
                />
            )}
        </div>
    );
};

export default Subjects;
